import React from 'react';
import { Grid, Typography } from '@mui/material';
import { JoinedMemory } from 'types/Memory';

type MemoryOverviewTabProps = {
  joinedMemory: JoinedMemory | undefined;
};

function MemoryOverviewTab({ joinedMemory }: MemoryOverviewTabProps) {
  return (
    <Grid
      item
      xs={12}
      borderRadius='10px'
      padding={2}
      bgcolor={(theme) => theme.palette.bgGray.main}
      sx={{ paddingTop: '8px' }}
    >
      <Typography
        sx={{
          fontSize: '16px',
          fontStyle: 'normal',
          background: '#F5F5F5',
          borderRadius: '6px',
          whiteSpace: 'pre-line',
        }}
      >
        {joinedMemory?.attributes.overview || '- -'}
      </Typography>
    </Grid>
  );
}

export default MemoryOverviewTab;
